import {MessengerApi} from "@core/api";

export default class Chat {

    id = null;
    chat = null;
    messages = [];
    messageCallbackIncrement = 1;
    messageCallbacks = {};
    initRequestPromise = null;
    initCompleted = false;
    initCallbacks = [];

    constructor(id) {
        this.id = id;
    }

    getId() {
        return this.id;
    }

    init() {
        return new Promise((resolve, reject) => {
            if (this.initCompleted) {
                resolve(this.chat);
            } else {
                if (this.initRequestPromise) {
                    this.initCallbacks.push(() => {
                        resolve(this.chat);
                    });
                    return;
                }

                this.initRequestPromise = MessengerApi.getChatByRequestId(this.id).then((r) => {
                    this.initCompleted = true;
                    this.chat = r.data;
                    this.messages = r.data.messages;

                    this.__emitMessages(this.messages);
                    this.initCallbacks.forEach(cb => cb());
                    this.initCallbacks = [];
                    resolve(this.chat);
                }).catch(reject);
            }
        });
    }

    send(message) {
        return MessengerApi.sendMessage(this.chat.id, message).then((r) => {
            this.messages.push(r.data);
            this.__emitMessages([r.data]);
        });
    }

    subscribe(callback) {
        let id = this.messageCallbackIncrement;
        this.messageCallbacks[id] = callback;
        this.messageCallbackIncrement++;

        if (this.messages.length) {
            callback(this.messages);
        }

        return id;
    }

    unsubscribe(id) {
        if (this.messageCallbacks[id]) {
            delete this.messageCallbacks[id];
        }
    }

    __emitMessages(messages) {
        Object.keys(this.messageCallbacks).forEach(k => {
            this.messageCallbacks[k](messages);
        });
    }
};
